import HeaderTextButton from "@/components/HeaderTextButton.tsx";
import {useMemo} from "react";
import BannerUpsertDialog from "@/features/banners/components/BannerUpsertDialog.tsx";
import {Banner, SortField, useBanners, useDeleteBanner} from "@/hooks/useBanners.ts";
import BannerTable from "@/features/banners/components/BannerTable.tsx";
import {useQueryModal} from "@/hooks/useQueryModal.ts";
import {useTableQuery} from "@/hooks/useTableQuery.ts";

export default function AdminBannersPage() {
    const {
        searchParams,
        editId,
        isNew,
        modalOpen,
        setParam,
        openCreate,
        openEdit,
        closeModal,
    } = useQueryModal();

    const {
        page,
        size,
        sortBy,
        sortOrder,
        setPage,
        onRequestSort,
    } = useTableQuery<SortField>({
        searchParams,
        setParam,
        defaultPage: 0,
        defaultSize: 10,
        defaultSortBy: "title",
        defaultSortOrder: "desc",
    });

    const {
        data: result,
        isLoading,
        isError
    } = useBanners({page, size, sortBy, sortOrder});

    const {mutateAsync: deleteBanner} = useDeleteBanner();

    const initialForDialog: Partial<Banner> | null = useMemo(() => {
        if (isNew) return null;
        if (editId) return result.items.find((c: Banner) => c.id === editId) ?? null;
        return null;
    }, [isNew, editId, result]);

    return (
        <>
            <HeaderTextButton
                title="Banners"
                description="Manage the banners displayed on the homepage."
                label="Add Banner"
                onClick={openCreate}
            />

            <BannerTable
                content={result}
                isLoading={isLoading}
                isError={isError}
                onCreate={openCreate}
                onEdit={openEdit}
                onDelete={deleteBanner}
                setPage={setPage}
                sortBy={sortBy}
                sortOrder={sortOrder}
                onRequestSort={onRequestSort}
            />

            <BannerUpsertDialog open={modalOpen} initial={initialForDialog} onClose={closeModal}/>

        </>
    );

}
